import React, { Component } from 'react';
import { Button, Container, Form, FormGroup, Label, Input } from 'reactstrap';

class PublicationsSave extends Component {
  constructor() {
    super();
    this.state = {
      loadingFile: false,
    };

    this.onCancel = this.onCancel.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onCancel() {
    this.props.history.push('/admin');
  }

  onChange(el) {
    this.setState({
      [el.target.name]: el.target.value,
    });
  }

  onFileChange(el) {
    let files = el.target.files;
    let propertyName = el.target.name;

    if (files.length) {
      this.setState(
        {
          loadingFile: true,
          [propertyName]: files[0],
        },
        () => {
          let fr = new FileReader();
          fr.addEventListener(
            'load',
            () =>
              this.setState({
                loadingFile: false,
                [propertyName]: fr.result,
              }),
            false
          );
          fr.readAsDataURL(this.state[propertyName]);
        }
      );
    }
  }

  async onSave(e) {
    e.preventDefault();
    await this.props.savePublication(this.state);

    this.props.history.push('/admin');
  }

  render() {
    return (
      <Container>
        <h3 className="display-4">Salvar publicação</h3>
        <Form onSubmit={this.onSave}>
          <FormGroup>
            <Label for="title">Título</Label>
            <Input
              type="text"
              name="title"
              id="title"
              required
              onChange={this.onChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="description">Descrição</Label>
            <Input
              type="textarea"
              name="description"
              required
              id="description"
              onChange={this.onChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="link">Link</Label>
            <Input
              type="text"
              name="link"
              id="link"
              required
              onChange={this.onChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="image">Imagem</Label>
            <Input
              type="file"
              name="image"
              id="image"
              required
              onChange={this.onFileChange}
              disabled={this.state.loadingFile}
            />
          </FormGroup>
          <div className="clearfix">
            <Button
              className="float-left"
              color="secondary"
              onClick={this.onCancel}
            >
              Voltar
            </Button>
            <Button
              type="submit"
              className="float-right"
              color="success"
              disabled={this.state.loadingFile}
            >
              Salvar
            </Button>
          </div>
        </Form>
      </Container>
    );
  }
}

export default PublicationsSave;



// WEBPACK FOOTER //
// ./src/components/templates/Admin/PublicationsSave/PublicationsSave.js